var map = {
	"./Tool.svg": 14401,
	"./UtentiWeb.svg": 50470,
	"./UtenzeGestite.svg": 68937,
	"./amr gest.svg": 51874,
	"./gateway.svg": 41351,
	"./mr gest.svg": 19157,
	"./receiver.svg": 90300,
	"./wfm gest.svg": 37910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70621;